module.exports = __webpack_public_path__ + "static/media/iconCanvas02.56021ba0.svg";